import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// Get all services +
export const getAllServices = createAsyncThunk(
  "service/getAllServices",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/workshops/`);
      console.log("response data", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Check Tariffs +
export const checkTariffs = createAsyncThunk(
  "service/checkTariffs",
  async (args, thunkAPI) => {
    try {
      const headers = {};

      // якщо передали токен явно (юзер ще не залогінений)
      if (args?.token) {
        headers["Authorization"] = `Bearer ${args.token}`;
      }

      const response = await axiosNewApiInstance.get(
        `/api/v1/workshops/check_tariffs`,
        Object.keys(headers).length ? { headers } : {}
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail,
      });
    }
  }
);

// Get chosen service details +
// export const getServiceDetails = createAsyncThunk(
//   "service/getServiceDetails",
//   async (_, thunkAPI) => {
//     try {
//       const response = await axiosNewApiInstance.get(`/api/v1/workshops/me`);
//       console.log("getServiceDetails", response.data);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue({
//         status: error.response?.status,
//         message: error.message,
//         details: error.response?.data.detail, // Залишаємо лише необхідні дані
//       });
//     }
//   }
// );

// Create new service +
export const createService = createAsyncThunk(
  "service/createService",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/workshops/`,
        payload
      );
      console.log("create service", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Update service data +
export const updateService = createAsyncThunk(
  "service/updateService",
  async ({ payload, companyId }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/workshops/${companyId}`,
        payload
      );
      console.log("updateService", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all legal entities of the service +
export const getLegalEntities = createAsyncThunk(
  "service/getLegalEntities",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/organizations/`);
      console.log("getLegalEntities", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Add Legal Entity to the service +
export const addLegalEntity = createAsyncThunk(
  "service/addLegalEntity",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/organizations/`,
        payload
      );
      console.log("addLegalEntity", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Edit legal entity of the service +
export const editLegalEntity = createAsyncThunk(
  "service/editLegalEntity",
  async (payload, thunkAPI) => {
    try {
      const { org_id, ...editedData } = payload;
      const response = await axiosNewApiInstance.patch(
        `/api/v1/organizations/${org_id}`,
        editedData
      );
      console.log("editLegalEntity", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete legal entity of the service +
export const deleteLegalEntity = createAsyncThunk(
  "service/deleteLegalEntity",
  async (org_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/organizations/${org_id}`
      );
      console.log("deleteLegalEntity", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
